export default "__VITE_ASSET__ChyUIfrg__"